import { z } from "zod";

export const artistStatsSchema = z.object({
  spotify: z.object({
    popularity: z.number(),
    followers: z.number(),
    monthlyListeners: z.number().nullish(),
    topCities: z
      .array(
        z.object({
          city: z.string(),
          numberOfListeners: z.number(),
          country: z.string(),
          region: z.string().nullish(),
        }),
      )
      .nullish(),
  }),
});
